const GAME_OVER_MODES = {
  INFINITY: {
    value: '',
    name: 'Infinity',
    desc: 'The game never ends or must be stopped manually'
  },
  SPEED: {
    value: 'speed',
    name: 'Speed!',
    desc: 'The game is over when one team finishes'
  },
  ALL: {
    value: 'all',
    name: 'All done',
    desc: 'The game is over when all team finish'
  },
  MAJORITY: {
    value: 'majority',
    name: 'Majority',
    desc: 'The game is over when the majority of teams finishes'
  },
}

export default GAME_OVER_MODES
